import React, {useEffect, useRef, useState} from 'react';
import api from "../../../api/API_SERVERS";
import Toast from "../../../utils/components/Toast";

const PayPalButton = ({month}) => {
    const paypalRef = useRef(null);
    const [toast, setToast] = useState(null);

    const showToast = (message, type = "error") => {
        if (!message) return;
        setToast({message, type});
    };

    useEffect(() => {
        if (!window.paypal || !paypalRef.current) return;

        paypalRef.current.innerHTML = ""; // prevent duplicates

        const paypalButtons = window.paypal.Buttons({
            createOrder: async () => {
                const paymentType = month === 1 ? "monthly" : "yearly";

                const {data} = await api.post('/api/teachers/profile/paypal/create-order', {
                    paymentType
                });

                return data.orderId;
            },
            onApprove: async (data) => {
                const paymentType = month === 1 ? "monthly" : "yearly";
                // console.log(data.orderID, paymentType);
                await api.post('/api/teachers/profile/paypal/capture-order', {orderId: data.orderID, paymentType});
                showToast('რეგისტრაცია წარმატებით დასრულდა! ✅', 'success');
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            },
            onError: (err) => {
                console.error(err);
                showToast("Payment failed");
            }
        });

        paypalButtons.render(paypalRef.current);

        // Cleanup when unmounting or before re-render
        return () => {
            if (paypalButtons) {
                paypalButtons.close(); // properly removes the button from the DOM
            }
        };
    }, [month]);

    return (
        <div>
            {
                toast &&
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(null)}
                />
            }
            <div ref={paypalRef}/>
        </div>
    );
};

export default PayPalButton;